export const PX_PER_MM = 3.7795275591;
export const MM_PER_IN = 25.4;
